import { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { ChartContainer } from '@/components/atoms/Chart';
import { AreaChart, Area, XAxis, YAxis } from 'recharts';
import { ChartTooltip, ChartTooltipContent } from '@/components/atoms/Chart';
import { type Keyword, KEYWORD_CHART_DATA, KEYWORD_OPTIONS } from './mock/mockTutorial';

export default function TutorialChart() {
  const [selected, setSelected] = useState<Keyword>('어버이날');
  const { ref, inView } = useInView({
    threshold: 0.6, // 60% 보였을 때
    triggerOnce: true,
  });

  const handleClick = (keyword: Keyword) => () => {
    setSelected(keyword);
  };

  return (
    <div ref={ref} className="flex h-[191px] w-full flex-col rounded-[19px] bg-gr-100 p-[20px]">
      <TutorialChartHeader selected={selected} onClick={handleClick} />

      {/* ✅ 애니메이션 시작 조건 */}
      {inView && (
        <ChartContainer config={{}} className="min-h-[40px] w-full">
          <AreaChart
            data={KEYWORD_CHART_DATA[selected]}
            margin={{ top: 0, right: 16, bottom: 0, left: 16 }}
          >
            <XAxis
              dataKey="date"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              tick={{
                fontSize: 9.44,
                fontWeight: 500,
                fill: '#939393',
                textAnchor: 'middle',
              }}
            />
            <YAxis hide domain={['auto', 'dataMax + 10']} />
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent className="rounded-sm bg-white" />}
            />
            <defs>
              <linearGradient id="fillMention" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#4B93FF" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#4B93FF" stopOpacity={0.1} />
              </linearGradient>
            </defs>
            <Area
              dataKey="언급량"
              type="natural"
              fill="url(#fillMention)"
              fillOpacity={0.4}
              stroke="#4B93FF"
              dot={({ cx, cy }) => (
                <circle cx={cx} cy={cy} r={4} stroke="#4B93FF" strokeWidth={2} fill="#4B93FF" />
              )}
              label={{
                position: 'top',
                fontSize: 12,
                fontWeight: 500,
                fill: '#4B93FF',
                offset: 12,
              }}
            />
          </AreaChart>
        </ChartContainer>
      )}
    </div>
  );
}

import type { MouseEventHandler } from 'react';

const TutorialChartHeader = ({
  selected,
  onClick,
}: {
  selected: Keyword;
  onClick: (keyword: Keyword) => MouseEventHandler<HTMLButtonElement>;
}) => {
  return (
    <div className="flex flex-col gap-[6px]">
      <div className="text-[12px] font-semibold  text-gr-800">핵심 키워드 언급량</div>
      <div className="flex w-fit gap-[5px]">
        {KEYWORD_OPTIONS.map((keyword) => (
          <button
            key={keyword}
            onClick={onClick(keyword)}
            className={`rounded-[3.4px] border px-[8px] py-[4px] text-[11px] ${
              selected === keyword ? 'bg-black text-white' : 'bg-white text-gr-800 hover:bg-gr-400'
            }`}
          >
            {keyword}
          </button>
        ))}
      </div>
    </div>
  );
};
